module.exports = __webpack_public_path__ + "static/img/image378-1.0b0bd7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/news/image378-1.png
// module id = AE0w
// module chunks = 150